import React, { useState, useEffect } from 'react';
import apiClient from '../../../api/apiClient';
import { Form, InputGroup, Container, Row, Col, Pagination, Button, Table } from 'react-bootstrap';
import { getTags, downloadFile } from '../../../utils/utils';
import { GETREFERENCEDOC } from '../../../utils/ApiEndPoint';

const RefrenceList = ({ selectedItem = [], handelSave = () => { } }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [documents, setDocuments] = useState([]);
    const [selectedDocumentList, setSelectedDocumentList] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;

    useEffect(() => {
        fetchResource();
    }, []);
    useEffect(() => {
        setSelectedDocumentList(selectedItem ? selectedItem : []);
    }, [selectedItem]);
    const fetchResource = () => {
        setLoading(true);
        apiClient.get(GETREFERENCEDOC)
            .then((response) => {
                if (response.status === 200) {
                    setDocuments(response.data);
                } else {
                    setError('Failed to load refrence documents')
                }
            }).catch((error) => {
                setError('Failed to load refrence documents')
            }).finally(() => {
                setLoading(false);
            });
    };
    const handelDownload = (item) => {
        downloadFile(item.documentUrl, item.title)
    }
    const filteredDocuments = documents.filter(document => {
        const searchLower = search.toLowerCase();
        return (
            document?.title?.toLowerCase().includes(searchLower) ||
            (Array.isArray(document.tags) ? document.tags.join(' ').toLowerCase() : '').includes(searchLower)
        );
    });

    const paginatedVideos = filteredDocuments.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const totalPages = Math.ceil(filteredDocuments.length / pageSize);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const handelSelected = (document) => {
        const isSelected = selectedDocumentList.length && selectedDocumentList?.some(v => (v._id === document._id || v.refId === document._id));
        if (isSelected) {
            setSelectedDocumentList(prev => prev.filter(v => (v._id !== document._id && v.refId !== document._id)));
        } else {
            setSelectedDocumentList(prev => [...prev, document]);            
        }
    }
    if (loading) return <p className='p-2 w-100 text-center m-3 bg-light'>Loading questions...</p>;
    if (error) return <p className='p-2 w-100 text-center m-3 bg-light'>{error}</p>;
    return (
        <Container fluid className="mt-2 px-4">
            <Row className="mb-2">
                <Col md={12}>
                    <InputGroup>
                        <Form.Control
                            placeholder="Search document..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                    </InputGroup>
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                <Table responsive className='mytable'>
                        <thead >
                            <tr>
                                <th className='txt-center'>S.No.</th>
                                <th className='text-nowrap'>Title</th>
                                <th className='text-nowrap'>Description</th>
                                <th className='text-nowrap'>Keywords</th>
                                <th className='text-nowrap'>Document Size</th>
                                <th className='text-nowrap'>Select</th> 
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedVideos.map((document, idx) => {

                                return <tr key={idx + (currentPage - 1) * pageSize}>
                                    <td>
                                        {(currentPage - 1) * pageSize + idx + 1}
                                    </td>
                                    <td><a style={{cursor:'pointer'}}onClick={(e)=>handelDownload(document)}>{document.title}</a></td>
                                    <td>{document.description}</td>
                                    <td>{document.tags && document.tags.length ? getTags(document.tags) : ''}</td>
                                    <td>{document.size ? document.size : ''}</td>
                                    <td>
                                        <Form.Check type="checkbox" className='listed-videos-checkbox' checked={selectedDocumentList.length && selectedDocumentList?.some(v => (v._id === document._id || v.refId === document._id))} onChange={() => {
                                            handelSelected(document);
                                        }} />
                                    </td>
                                </tr>
                            }
                            )}
                        </tbody>
                    </Table>
                </Col>
                <Col lg={12}>
                    <div className="d-flex justify-content-center">
                        <Pagination className='mypagination-listing'>
                            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                            {[...Array(totalPages)].map((_, idx) => (
                                <Pagination.Item
                                    key={idx + 1}
                                    active={currentPage === idx + 1}
                                    onClick={() => handlePageChange(idx + 1)}
                                >
                                    {idx + 1}
                                </Pagination.Item>
                            ))}
                            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                            <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                        </Pagination>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col lg={12} className='text-center '>
                    <Button className='purple-btn' style={{float:'right', minWidth:'180px', maxWidth:'180px'}} onClick={() => {
                        handelSave(selectedDocumentList);
                    }}>Add Reference File</Button>
                </Col>
            </Row>
        </Container >
    );
};

export default RefrenceList;